export const environment = {
  production: false,
  apiUrl: 'https://api.dev.support-desk.savinda.lk/api/v1',
  wsUrl: 'https://api.dev.support-desk.savinda.lk',

  // apiUrl: 'http://localhost:3000/api/v1',
  // wsUrl: 'http://localhost:3000',

  PORTAL: 'https://dev.portal.savinda.lk',

  cache: {
    maxSize: 5000,

    /**
     * Max Age
     * 
     * @type string
     * @default 1h
     * @description TTL of the cache. Use the below format
     * 1d2h3m4s5u
     * - d - Days
     * - h - hours
     * - m - minutes
     * - s - seconds
     * - u - milliseconds
     */
    maxAge: '1d'
  },
};
